import { useEffect } from "react"
import { useOptimization } from "hooks/optimizer"
import { SelectedTypedInstrument } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { OptimizedPositionSet, OptimizationConfiguration } from "./types"

export const useAutoRunOptimization = (
  instrument: SelectedTypedInstrument | null,
  modelId: string,
  endDate: IsoDate,
  base: SelectedTypedInstrument | null,
  setOptimizeConfiguration: (configuration: OptimizationConfiguration) => void,
  optimizeConfiguration: OptimizationConfiguration | null,
  setComparisonInstrument: (instrument: OptimizedPositionSet | null) => void,
  isOptimizeExperimentsEnabled: boolean,
  isOptimizedExperimentsDrawerOpen: boolean,
): void => {
  const { runOptimization, getConfiguration, optimizedPositionSet } = useOptimization(
    instrument,
    modelId,
    endDate,
    base,
    { overrideConfiguration: optimizeConfiguration },
  )

  useEffect(() => {
    const canRunOptimization = Boolean(
      isOptimizeExperimentsEnabled
      && optimizeConfiguration
      && endDate
      && instrument
      && modelId,
    )

    if (!canRunOptimization) {
      return
    }

    if (optimizeConfiguration?.on === endDate || isOptimizedExperimentsDrawerOpen) {
      return
    }

    runOptimization()
    const configuration = getConfiguration()
    setOptimizeConfiguration(configuration)
  }, [
    runOptimization,
    setOptimizeConfiguration,
    endDate,
    optimizeConfiguration,
    getConfiguration,
    instrument,
    modelId,
    base,
    isOptimizeExperimentsEnabled,
    isOptimizedExperimentsDrawerOpen,
  ])

  useEffect(() => {
    if (!isOptimizeExperimentsEnabled || !optimizedPositionSet) {
      return
    }

    setComparisonInstrument(optimizedPositionSet)
  }, [optimizedPositionSet, setComparisonInstrument, isOptimizeExperimentsEnabled])
}
